<template>
    <div>
        <strong>Política de Privacidad</strong>
        <p>
            Quiz & Jogos Online desarrolló la aplicación Serene como
            Una aplicación con anuncios. Este SERVICIO es proporcionado por
            Quiz & Games Online es gratuito y está destinado a ser utilizado como
            este.
        </p>
        <p>
            Esta página se utiliza para informar a los visitantes sobre
            Mis políticas con respecto a la recopilación, uso y divulgación de información personal
            en caso de que alguien decida utilizar mi Servicio.
        </p>
        <p>
            Si elige utilizar mi Servicio, entonces acepta
            la recopilación y el uso de información en relación con este
            política. La información personal que recopilo es
            se utiliza para proporcionar y mejorar el Servicio. No utilizaré ni compartiré su información con
            cualquier persona excepto como se describe en esta Política de Privacidad.
        </p>
        <p>
            Los términos utilizados en esta Política de Privacidad tienen los mismos significados
            que en nuestros Términos y Condiciones, accesibles en
            Sereno, a menos que se defina lo contrario en esta Política de Privacidad.
        </p>
        <p><strong>Recopilación y uso de información</strong></p>
        <p>
            Para una mejor experiencia al utilizar nuestro Servicio, le rogamos que:
            Es posible que le solicite que nos proporcione cierta información de identificación personal, que incluye,
            entre otros, nombre y correo electrónico. La información que
            Los datos que solicito se conservarán en su dispositivo y no serán recopilados por mí de ninguna manera.
        </p>
        <div>
            <p>
                La aplicación utiliza servicios de terceros que pueden recopilar
                información utilizada para identificarlo.
            </p>
            <p>
                Enlace a la política de privacidad de los proveedores de servicios externos utilizados
                por la aplicación
            </p>
            <ul>
                <li><a href="https://www.google.com/policies/privacy/" target="_blank"
                        rel="noopener noreferrer">Servicios de Google Play</a></li>
                <li><a href="https://support.google.com/admob/answer/6128543?hl=es" target="_blank"
                        rel="noopener noreferrer">AdMob</a></li>
                <li><a href="https://firebase.google.com/support/privacy" target="_blank"
                        rel="noopener noreferrer">Google Analytics para Firebase</a></li>
                <li><a href="https://firebase.google.com/support/privacy/" target="_blank"
                        rel="noopener noreferrer">Firebase Crashlytics</a></li>
            </ul>
        </div>
        <p><strong>Datos de registro</strong></p>
        <p>
            Quiero informarle que siempre que usted
            Utilice mi Servicio, en caso de error en la aplicación
            Recopilo datos e información (a través de productos de terceros)
            en su teléfono llamado Datos de Registro. Estos datos de registro pueden
            incluye información como la dirección IP de su dispositivo, el nombre del dispositivo, la versión del
            sistema operativo,
            configuración de la aplicación al utilizar mi Servicio,
            la hora y fecha de su uso del Servicio y otras estadísticas.
        </p>
        <p><strong>Galletas</strong></p>
        <p>
            Las cookies son archivos con una pequeña cantidad de datos que se almacenan en el navegador del usuario.
            Se utilizan comúnmente como identificadores únicos anónimos. Estos son enviados
            a su navegador desde los sitios web que visita y está
            almacenados en la memoria interna de su dispositivo.
        </p>
        <p>
            Este Servicio no utiliza estas “cookies” de forma explícita. Sin embargo,
            La aplicación puede utilizar código y bibliotecas de terceros que utilizan
            “cookies” para recopilar información y mejorar sus servicios.
            Tienes la opción de aceptar o rechazar estas cookies.
            y saber cuándo se envía una cookie a su dispositivo. Si usted
            Si decide rechazar nuestras cookies, es posible que no pueda utilizar algunas de las
            partes de este Servicio.
        </p>
        <p><strong>Proveedores de servicios</strong></p>
        <p>
            Puedo contratar empresas de terceros y
            individuos por las siguientes razones:
        </p>
        <ul>
            <li>Para facilitar nuestro Servicio;</li>
            <li>Para proporcionar el Servicio en nuestro nombre;</li>
            <li>Para realizar servicios relacionados con el Servicio; o</li>
            <li>Para ayudarnos a analizar cómo se utiliza nuestro Servicio.</li>
        </ul>
        <p>
            Quiero informar a los usuarios de este Servicio
            que estos terceros tengan acceso a su Información Personal. El motivo es realizar las tareas asignadas.
            ellos en nuestro nombre. Sin embargo, se les exige que no lo hagan.
            divulgar o utilizar la información para cualquier otro propósito.
        </p>
        <p><strong>Seguridad</strong></p>
        <p>
            Valoro su confianza al brindarnos su
            Información personal, por lo que nos esforzamos por utilizar medios razonables
            formas comercialmente aceptables de protegerlos. Pero recuerda que ningún método
            La transmisión a través de Internet o el método de almacenamiento electrónico es 100% seguro y confiable, y
            no puedo
            Garantizamos su absoluta seguridad.
        </p>
        <p><strong>Enlaces a otros sitios</strong></p>
        <p>
            Este Servicio puede contener enlaces a otros sitios web. Si haces clic en
            un enlace de terceros, serás dirigido a este sitio. tenga en cuenta
            que estos sitios externos no son operados por mí.
            Por lo tanto, te recomiendo encarecidamente que revises el
            Política de privacidad de estos sitios. I
            No tengo control ni asumo ninguna responsabilidad por el contenido,
            políticas o prácticas de privacidad de sitios o servicios de terceros.
        </p>
        <p><strong>Privacidad de los niños</strong></p>
        <div>
            <p>
                Estos Servicios no están destinados a niños menores de 13 años. No recopilo
                recopilar a sabiendas información de identificación personal de niños menores de 13 años. En el caso
                de descubrir que un niño menor de 13 años nos ha proporcionado
                información personal, la borro inmediatamente
                desde nuestros servidores. Si usted es padre o tutor y sabe que
                Su hijo nos ha proporcionado información personal, por favor póngase en contacto conmigo para que
                Puedo tomar las medidas necesarias.
            </p>
        </div>
        <p><strong>Cambios a esta Política de Privacidad</strong></p>
        <p>
            Puedo actualizar nuestra Política de Privacidad a partir de
            De vez en cuando. Por lo tanto, le recomendamos que revise esta página.
            Periódicamente para comprobar si hay cambios. voy a ir
            notificarle cualquier cambio publicando la nueva Política de Privacidad en esta página.
        </p>
        <p>Esta política entra en vigor a partir del 22/02/2024</p>
        <p><strong>Contáctenos</strong></p>
        <p>
            Si tienes alguna pregunta o sugerencia sobre mi
            Política de privacidad, no dudes en contactarme por correo electrónico quizejogosonline@gmail.com.</p>
    </div>
</template>

<script>
export default {
    name: 'SerenePrivacyPolicyES'
}
</script>